// 눈속임 카드번호 마스킹 (앞에 12개 * 붙이기)
export const fakeCardMask = (
  lastFourDigits?: string | number,
  starCount: number = 12,
) => {
  if (!lastFourDigits) return '';
  const digits = String(lastFourDigits).replace(/\D/g, '');
  if (digits.length === 0) return '';
  return '*'.repeat(starCount) + digits;
};

// 뒤 4자리 제외하고 * 처리
export const maskNumber = (number: string) => {
  if (!number) return '-';
  if (number.length <= 4) return number;
  const visibleDigits = number.slice(-4);
  const maskedPart = '*'.repeat(number.length - 4);
  return maskedPart + visibleDigits;
};
